import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ConfirmButton from '../ConfirmButton';
import { Button, PlainButton } from '../Controls';

/**
 * Taps straight through when there is nothing to confirm; with `onCancel` it is a step in a flow and asks first.
 */
const ActionableButton = ({ onClick, disabled, children, onCancel, plain, prompt }) => {
  const onClickCallback = useCallback(() => onClick && onClick(), [onClick]);

  if (!onClick) {
    return children;
  }

  if (onCancel) {
    return (
      <ConfirmButton
        onConfirm={onClickCallback}
        onCancel={onCancel}
        disabled={disabled}
        plain={plain}
        prompt={prompt}
      >
        {children}
      </ConfirmButton>
    );
  }

  const ButtonType = plain ? PlainButton : Button;

  return (
    <ButtonType onClick={onClickCallback} disabled={disabled}>{children}</ButtonType>
  );
};

ActionableButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  plain: PropTypes.bool,
  onCancel: PropTypes.func,
  prompt: PropTypes.string,
};

ActionableButton.defaultProps = {
  disabled: false,
};

export default ActionableButton;
